import Vue from 'vue'

const PROJECT_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};

const PROJECT_SET_DESCRIPTION =(state, payload)=> {
            
    state.data.description = payload
};

const PROJECT_SET_STARTEDAT =(state, payload)=> {
            
    state.data.started_at = payload
};

const PROJECT_SET_ENDEDAT =(state, payload)=> {
            
    state.data.ended_at = payload
};

const PROJECT_SET_NUMBER =(state, payload)=> {
            
    state.data.number = payload
};

const PROJECT_SET_COMPANY =(state, payload)=> {
            
    state.data.company_ids = payload
};

const PROJECT_SET_ENTITIES =(state, payload)=> {
    
    state.data.entity_ids = payload
};

const PROJECT_SET_PROJECTS =(state, payload)=> {  
    
    state.projects=payload
    
};

const PROJECT_SET_PROJECT =(state, payload)=> {       
    
    state.data.name = payload.name  
    state.data.number = payload.number
    state.data.started_at=payload.started_at
    state.data.ended_at=payload.ended_at
    state.data.status = payload.status
    state.data.company_ids = payload.companies.map(c=>c.pivot.company_id)
    state.data.entity_ids = payload.entities.map(e=>e.pivot.entity_id)
    state.data.entities = payload.entities
    state.data.companies=payload.companies
        
};



const PROJECT_INIT_PROJECT =(state, payload)=> {       
    state.data.name = ''    
    state.data.number = ''
    state.data.started_at=''
    state.data.ended_at=''
    state.data.status = ''
    state.data.company_ids = []
    state.data.entity_ids = []
    state.data.entities = []
    state.data.companies = []
    
};

export default {
    PROJECT_SET_NAME,
    PROJECT_SET_NUMBER,
    PROJECT_SET_COMPANY,
    PROJECT_SET_ENTITIES,   
    PROJECT_SET_PROJECTS,
    PROJECT_SET_PROJECT,
    PROJECT_INIT_PROJECT,
    PROJECT_SET_DESCRIPTION,
    PROJECT_SET_STARTEDAT,
    PROJECT_SET_ENDEDAT
    

};